import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Multiselect, _mergeProps(_ctx.$attrs, {
      canClear: false,
      filterResults: false,
      searchable: true,
      delay: 150,
      canDeselect: false,
      mode: _ctx.mode,
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      options: _ctx.getCustomers,
      noOptionsText: "Ingen kunder å vise",
      noResultsText: "Ingen treff",
      closeOnSelect: true
    }), null, 16, ["mode", "modelValue", "options"])
  ]))
}